/**
 * Mirrors iOS `NativeHomeView.isReturningUser`: any browsing history (a region search or a
 * viewed property) or an enquiry/booking (`user_flow_token`). Being logged in alone does not count.
 */
const isReturningHomeUser = ({
  hasRecentSearch,
  recentlyViewedCount,
  userFlowToken,
}: {
  hasRecentSearch: boolean;
  recentlyViewedCount: number;
  userFlowToken?: string | null;
}): boolean => hasRecentSearch || recentlyViewedCount > 0 || Boolean(userFlowToken);

export default isReturningHomeUser;
